export default __webpack_public_path__ + "images/icon-message.fa9eaa5b0b24b59d950adc9afea2822f.svg";